import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Document } from '../models/document.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/api/documents`;

  getDocuments(): Observable<Document[]> {
    return this.http.get<any>(this.apiUrl).pipe(
      map(response => response.data.data),
      catchError((error) => {
        console.error('[DocumentsService] GET request failed', error);
        return throwError(() => error);
      })
    );
  }
}
